export default [
  {
    path: '',
    name: 'apps-plant-list',
    component: () => import(/* webpackChunkName: "apps-plant-list" */ '@/apps/plant/pages/PlantListPage.vue'),
    meta: {
      layout: 'content',
    },
  },
]
